module.exports = __webpack_public_path__ + "img/cms_newlogo.467e0242.png";